export default {
  root: ({ attrs }) => ({
    class: [
      'relative',

      // Alignment
      'inline-flex',
      'self-center',

      // Size
      { 'w-5 h-5': !attrs['size'], 'w-4 h-4': attrs['size'] === 'small' },

      // Misc
      'cursor-pointer',
      'select-none'
    ]
  }),
  box: ({ props, context, attrs }) => ({
    class: [
      // Alignment
      'flex',
      'items-center',
      'justify-center',

      // Size
      { 'w-5 h-5': !attrs['size'], 'w-4 h-4': attrs['size'] === 'small' },

      // Shape
      'rounded-xs',
      'border-2',

      // Colors
      {
        'border-gray-700 bg-surface-0 dark:border-surface-700 dark:bg-surface-900':
          !context.checked && !props.invalid,
        'border-primary-400 bg-primary-400':
          context.checked &&
          !props.disabled &&
          (attrs['gbTheme'] === 'primary' ||
            attrs['gbTheme'] === 'blue' ||
            attrs['gbTheme'] === undefined),
        'border-purple-300 bg-purple-300':
          context.checked && !props.disabled && attrs['gbTheme'] === 'purple',
        'border-green-300 bg-green-300':
          context.checked && !props.disabled && attrs['gbTheme'] === 'green',
        'border-gray-600 bg-gray-600': context.checked && props.disabled
      },

      // Invalid State
      { 'border-red-300 dark:border-red-400': props.invalid },

      // States
      {
        'peer-hover:border-gray-1000 hover:border-gray-1000':
          !props.disabled && !context.checked && !props.invalid,
        'peer-hover:bg-primary-500 peer-focus-visible:bg-primary-500':
          !props.disabled &&
          context.checked &&
          (attrs['gbTheme'] === 'primary' ||
            attrs['gbTheme'] === 'blue' ||
            attrs['gbTheme'] === undefined),
        'peer-hover:bg-purple-400 peer-focus-visible:bg-purple-400':
          !props.disabled && context.checked && attrs['gbTheme'] === 'purple',
        'peer-hover:bg-green-400 peer-focus-visible:bg-green-400':
          !props.disabled && context.checked && attrs['gbTheme'] === 'green',
        'peer-focus-visible:outline-none peer-focus-visible:outline-offset peer-focus-visible:ring peer-focus-visible:ring-offset-2 peer-focus-visible:border-gray-1000':
          !props.disabled,
        'peer-focus-visible:ring-primary-500':
          !props.disabled &&
          (attrs['gbTheme'] === 'primary' ||
            attrs['gbTheme'] === 'blue' ||
            attrs['gbTheme'] === undefined),
        'peer-focus-visible:ring-purple-400': !props.disabled && attrs['gbTheme'] === 'purple',
        'peer-focus-visible:ring-green-400': !props.disabled && attrs['gbTheme'] === 'green',
        'peer-hover:border-gray-1000': !props.disabled && context.checked,
        'cursor-not-allowed bg-gray-300 border-gray-600': props.disabled
      },

      // Transitions
      'transition-colors',
      'duration-200'
    ]
  }),
  input: ({ props }) => ({
    class: [
      'peer',

      // Size
      'w-full ',
      'h-full',

      // Position
      'absolute',
      'top-0 left-0',
      'z-10',

      // Spacing
      'p-0',
      'm-0',

      // Shape
      'opacity-0',
      'rounded-xs',
      'outline-none',
      'border-2 border-gray-700 dark:border-surface-700',

      // Misc
      'appearance-none',
      { 'cursor-pointer': !props.disabled }
    ]
  }),
  icon: {
    class: [
      // Font
      'text-base leading-none',

      // Size
      'w-4',
      'h-4',

      // Colors
      'text-white dark:text-surface-900',

      // Transitions
      'transition-all',
      'duration-200'
    ]
  }
}
